import {
  CompanyAttributes,
  SubRouteAttributes,
} from "@albatrosdeveloper/ave-models-package";
import { SourceToSetSerialEnum } from "@albatrosdeveloper/ave-models-package/lib/enums/source-to-set-serial.enum";
import SalesOfficeAttributes from "@albatrosdeveloper/ave-models-package/lib/schemas/configurations/sales-office/sales-office.entity";
import EmissionPointAttributes from "@albatrosdeveloper/ave-models-package/lib/schemas/documents/emission-point/emission-point.entity";
import { CommonModule } from "@angular/common";
import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  ElementRef,
  OnDestroy,
  TemplateRef,
  ViewChild,
} from "@angular/core";
import {
  FormBuilder,
  FormControl,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
} from "@angular/forms";
import { MatButtonModule } from "@angular/material/button";
import { MatOptionModule } from "@angular/material/core";
import {
  MatDialog,
  MatDialogModule,
  MatDialogRef,
} from "@angular/material/dialog";
import { MatExpansionModule } from "@angular/material/expansion";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatIcon, MatIconModule } from "@angular/material/icon";
import { MatInputModule } from "@angular/material/input";
import { MatMenuModule } from "@angular/material/menu";
import {
  MatPaginator,
  MatPaginatorIntl,
  MatPaginatorModule,
  PageEvent,
} from "@angular/material/paginator";
import { MatSelectChange, MatSelectModule } from "@angular/material/select";
import { MatSidenav, MatSidenavContainer } from "@angular/material/sidenav";
import { MatSlideToggle } from "@angular/material/slide-toggle";
import { MatSnackBar } from "@angular/material/snack-bar";
import { MatSort, MatSortModule } from "@angular/material/sort";
import { MatRowDef, MatTableModule } from "@angular/material/table";
import { MatTabsModule } from "@angular/material/tabs";
import { MatTooltipModule } from "@angular/material/tooltip";
import { ActivatedRoute, Router } from "@angular/router";
import { HoverMenuDirective } from "@fuse/directives/hover-menu/hover-menu.directive";
import { NgSelectComponent, NgSelectModule } from "@ng-select/ng-select";
import { FilterSectionComponent } from "app/common/components/filter-section/filter-section.component";
import { FilterComponent } from "app/common/components/filter/filter.component";
import { SearchService } from "app/layout/common/search-page/search-page.service";
import { ExportDialogComponent } from "app/layout/export-overlay/dialog/export-dialog.component";
import { ExportService } from "app/layout/export-overlay/export-overlay.service";
import { ExportOptions } from "app/layout/export-overlay/tasks/core/export-task.interfaces";
import { CustomMatPaginatorIntl } from "app/mock-api/common/customPaginatorIntl";
import { getCode } from "app/utils/method";
import { NgxMatSelectSearchModule } from "ngx-mat-select-search";
import { ReplaySubject, Subject, Subscription, take, takeUntil } from "rxjs";
import { debounceTime, distinctUntilChanged } from "rxjs/operators";
import { CompanyService } from "../../configuration/company/company.service.service";
import { SalesOfficeService } from "../../configuration/sales-office/sales-office.service";
import { ConfigurationFiltersComponent } from "../../filters/configuration-filters/configuration-filters.component";
import { DocumentsFiltersComponent } from "../../filters/documents-filters/documents-filters.component";
import { RoutesFiltersComponent } from "../../filters/routes-filters/routes-filters.component";
import { StatusFiltersComponent } from "../../filters/status-filters/status-filters.component";
import { SubRouteService } from "../../routing/sub-routes/sub-route.service";
import { EmissionPointService } from "./emission-point.service";
import { EMISSION_POINT_TITLE } from "./exports/emission-point.constants";
import { EmissionPointExport } from "./exports/emission-point.export";
import { ICreateEmissionPoint } from "./interfaces/create-emission-point.interface";
import { IUpdateEmissionPoint } from "./interfaces/update-emission-point.interface";

@Component({
  selector: "app-emission-point",
  templateUrl: "./emission-point.component.html",
  styleUrls: ["./emission-point.component.scss"],
  standalone: true,
  imports: [
    CommonModule,
    MatTableModule,
    MatDialogModule,
    MatButtonModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatSortModule,
    MatPaginatorModule,
    MatIcon,
    MatSlideToggle,
    MatSelectModule,
    MatOptionModule,
    MatTooltipModule,
    MatExpansionModule,
    MatMenuModule,
    MatButtonModule,
    MatIconModule,
    MatRowDef,
    MatSidenav,
    MatSidenavContainer,
    FormsModule,
    NgSelectComponent,
    NgSelectModule,
    MatTabsModule,
    NgxMatSelectSearchModule,
    StatusFiltersComponent,
    DocumentsFiltersComponent,
    FilterSectionComponent,
    FilterComponent,
    ConfigurationFiltersComponent,
    RoutesFiltersComponent,
    HoverMenuDirective,
  ],
  providers: [
    { provide: MatPaginatorIntl, useClass: CustomMatPaginatorIntl },
    EmissionPointExport,
  ],
})
export class EmissionPointComponent implements AfterViewInit, OnDestroy {
  getCode = getCode;
  displayedColumns: string[] = [
    "name",
    "subroute",
    "sales",
    "status",
    "actions",
  ];
  currentCreateEmissionPoint: ICreateEmissionPoint =
    this.initializeCreateEmissionPoint();
  currentUpdateEmissionPoint:
    | (EmissionPointAttributes & { subRouteId: string })
    | undefined;

  dataSource: EmissionPointAttributes[] = [];
  salesOfficeList: SalesOfficeAttributes[] = [];
  selectedCompanyIds: string[] = [];
  subRouteList: SubRouteAttributes[] = [];
  subRouteListWithCodeName: (SubRouteAttributes & { codeWithName: string })[] =
    [];
  companyList: CompanyAttributes[] = [];
  typeList: number[] = Object.values(SourceToSetSerialEnum).filter(
    (value): value is number => typeof value === "number"
  );
  sourceToSetSerialEnum = SourceToSetSerialEnum;

  searchQuery: string = "";
  totalItems: number = 0;
  pageSize: number = 50;
  pageIndex: number = 1;

  dialogRefAdd: MatDialogRef<any>;
  dialogRefEdit: MatDialogRef<any>;

  isSalesOfficeDisabled: boolean = false;
  isSubRouteDisabled: boolean = false;

  @ViewChild("editModal") editModal!: TemplateRef<any>;
  @ViewChild("addModal") addModal!: TemplateRef<any>;
  @ViewChild("deleteDialog") deleteDialog!: TemplateRef<any>;
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;
  @ViewChild("searchInput") searchInput!: ElementRef;

  protected _onDestroy = new Subject<void>();

  /** control for the selected application for multi-selection */
  public salesOfficeMultiCtrl: FormControl<SalesOfficeAttributes[]> =
    new FormControl<SalesOfficeAttributes[]>([]);

  /** control for the MatSelect filter keyword multi-selection */
  public salesOfficeMultiFilterCtrl: FormControl<string> =
    new FormControl<string>("");

  /** list of application filtered by search keyword */
  public filteredSalesOffice: ReplaySubject<SalesOfficeAttributes[]> =
    new ReplaySubject<SalesOfficeAttributes[]>(1);

  /** local copy of filtered companies to help set the toggle all checkbox state */
  protected filteredSalesOfficeCache: SalesOfficeAttributes[] = [];

  /** flags to set the toggle all checkbox state */
  isIndeterminate = false;
  isChecked = false;

  //BUSCADOR
  searchSubscription: Subscription;

  selectedStatuses: [] = [];
  form: FormGroup<{
    companyId: FormControl<string>;
    typeEmissionPointId: FormControl<string[]>;
    subRouteId: FormControl<number[]>;
  }>;

  // Lazy loading flags
  loadFiltersData = false;
  filteredBySubRoute: {
    isFiltered: boolean;
    subRouteId?: string;
    subRouteCode?: string;
    subRouteName?: string;
  } = { isFiltered: false };

  constructor(
    private readonly emissionPointService: EmissionPointService,
    private readonly salesOfficeService: SalesOfficeService,
    private readonly subRouteService: SubRouteService,
    private readonly companyService: CompanyService,
    private readonly searchService: SearchService,
    private dialog: MatDialog,
    private snackBar: MatSnackBar,
    private cdr: ChangeDetectorRef,
    public exportService: ExportService,
    private emissionPointExport: EmissionPointExport,
    private fb: FormBuilder,
    private router: Router,
    private route: ActivatedRoute
  ) {
    this.form = this.fb.group({
      companyId: [null],
      typeEmissionPointId: [[]],
      subRouteId: [[]],
    }) as FormGroup<{
      companyId: FormControl<string>;
      typeEmissionPointId: FormControl<string[]>;
      subRouteId: FormControl<number[]>;
    }>;
  }

  ngAfterViewInit(): void {
    this.onHandleSearch();
    this.setupPaginationAndSorting();
    this.subruteFilterListener();


    // Handle query parameters for sub-route filtering
    this.route.queryParams.subscribe((params) => {
      if (params["subRouteId"]) {
        this.filteredBySubRoute = {
          isFiltered: true,
          subRouteId: params["subRouteId"],
          subRouteCode: params["subRouteCode"],
          subRouteName: params["subRouteName"],
        };

        const subRouteIdIsNumber = Number(params["subRouteId"]);

        // Set the form control for subRouteId
        this.form.patchValue({
          subRouteId: [subRouteIdIsNumber],
        });

   
      } else {
        this.filteredBySubRoute = { isFiltered: false };
        this.findAllWithCount();
      }

    });
  }

  public handleFilterClean() {
    this.form.reset({
      typeEmissionPointId: [],
    });

    this.selectedStatuses = [];
    this.clearSubRouteFilter();

    this.findAllWithCount();
  }

  public clearSubRouteFilter() {
    this.filteredBySubRoute = { isFiltered: false };
    this.router.navigate([], {
      relativeTo: this.route,
      queryParams: {},
    });
  }

  subruteFilterListener(): void {
    this.form
      .get("subRouteId")
      ?.valueChanges.pipe(
        debounceTime(300),
        distinctUntilChanged(),
        takeUntil(this._onDestroy)
      )
      .subscribe(() => {
        //Resets pagination and loads table data applying the current filters.
        this.pageIndex = 1;
        this.findAllWithCount();
      });
  }

  private fetchAllSubRoute(includeSubRouteId?: string): void {
    this.subRouteService.findAllWithoutEmissionPoints().subscribe({
      next: (res) => {
        let subRouteList = res.data;

        // Si estamos editando y hay una sub-ruta actual, necesitamos incluirla
        if (includeSubRouteId && this.currentUpdateEmissionPoint?.subRoute) {
          const currentSubRoute = this.currentUpdateEmissionPoint.subRoute;

          // Verificar si la sub-ruta actual ya está en la lista (para evitar duplicados)
          const isAlreadyInList = subRouteList.some(
            (subRoute) =>
              subRoute._id?.toString() === currentSubRoute._id?.toString() ||
              subRoute.id === currentSubRoute.id
          );

          // Si no está en la lista, agregarla
          if (!isAlreadyInList) {
            //@ts-ignore
            subRouteList = [currentSubRoute, ...subRouteList];
          }
        }

        this.subRouteList = subRouteList;
        this.subRouteListWithCodeName = this.subRouteList.map((subRoute) => ({
          ...subRoute,
          codeWithName: `${subRoute.externalKeys?.code} - ${subRoute.name}`,
        }));
      },
      error: (err) => {
        this.snackBar.open(err.error.message || "Error al obtener rutas sin puntos de emisión.","Cerrar",{ duration: 5000});
      },
    });
  }

  private fetchAllCompany(): void {
    this.companyService.findToComboBox().subscribe({
      next: (res) => {
        this.companyList = res.data;
      },
      error: (err) => {
        this.snackBar.open(err.error.message || "Error al obtener compañias.","Cerrar",{ duration: 5000});
      },
    });
  }

  private fetchAllApplication(): void {
    this.salesOfficeService.findToComboBox().subscribe({
      next: (res) => {
        this.salesOfficeList = res.data;
        this.filteredSalesOffice.next(this.salesOfficeList);
        if (this.currentUpdateEmissionPoint?.salesOffices) {
          this.filteredSalesOffice.pipe(take(1)).subscribe((materials) => {
            const selectedMaterials = materials.filter((material) =>
              this.currentUpdateEmissionPoint.salesOffices
                .map((r) => r._id.toString())
                .includes(material._id.toString())
            );
            this.salesOfficeMultiCtrl.setValue(selectedMaterials);
          });
        }
        // listen for search field value changes
        this.salesOfficeMultiFilterCtrl.valueChanges
          .pipe(takeUntil(this._onDestroy))
          .subscribe(() => {
            this.filterVisitMulti();
            this.setToggleAllCheckboxStateVisit();
          });
      },
      error: (err) => {
        this.snackBar.open(err.error.message || "Error al obtener aplicaciones.","Cerrar",{ duration: 5000});
      },
    });
  }

  protected filterVisitMulti() {
    if (!this.salesOfficeList) {
      return;
    }
    // get the search keyword
    let search = this.salesOfficeMultiFilterCtrl.value;
    if (!search) {
      this.filteredSalesOfficeCache = this.salesOfficeList;
      this.filteredSalesOffice.next(this.salesOfficeList);
      return;
    } else {
      search = search.toLowerCase();
    }
    // Filtrar las rutas por nombre o código
    this.filteredSalesOfficeCache = this.salesOfficeList.filter((material) => {
      const nameMatches = material.name.toLowerCase().indexOf(search) > -1;
      return nameMatches; // Devolver true si coincide con el nombre o el código
    });
    this.filteredSalesOffice.next(this.filteredSalesOfficeCache);
  }

  toggleSelectAll(selectAllValue: boolean) {
    this.filteredSalesOffice
      .pipe(take(1), takeUntil(this._onDestroy))
      .subscribe((val) => {
        if (selectAllValue) {
          this.salesOfficeMultiCtrl.patchValue(val);
        } else {
          this.salesOfficeMultiCtrl.patchValue([]);
        }
      });
  }
  protected setToggleAllCheckboxStateVisit() {
    let filteredLength = 0;
    if (this.salesOfficeMultiCtrl && this.salesOfficeMultiCtrl.value) {
      this.filteredSalesOfficeCache.forEach((el) => {
        if (this.salesOfficeMultiCtrl.value.indexOf(el) > -1) {
          filteredLength++;
        }
      });
      this.isIndeterminate =
        filteredLength > 0 &&
        filteredLength < this.filteredSalesOfficeCache.length;
      this.isChecked =
        filteredLength > 0 &&
        filteredLength === this.filteredSalesOfficeCache.length;
    }
  }

  private initializeCreateEmissionPoint(): ICreateEmissionPoint {
    return { name: "", type: null, companyId: "" };
  }

  private setupPaginationAndSorting(): void {
    this.paginator.page.subscribe(() => this.findAllWithCount());
    this.sort.sortChange.subscribe(() => {
      this.paginator.pageIndex = 0;
      this.findAllWithCount();
    });
  }

  findAllWithCount(): void {
    // const pageIndex = this.paginator.pageIndex + 1;
    const sortField = this.getSortField();
    const sortDirection: "ASC" | "DESC" =
      this.sort.direction === "asc" ? "ASC" : "DESC";
    //   const companyCodes = this.getSelectedCompanyCodes(this.selectedCompanyIds);

    this.emissionPointService
      .findAllWithCount(
        {
          currentPage: this.pageIndex,
          limitPerPage: this.pageSize,
          search: this.searchQuery,
          sort: sortField,
          sortDirection: sortDirection,
        },
        this.form.get("companyId").value,
        this.form.get("typeEmissionPointId").value,
        this.selectedStatuses,
        this.form.get("subRouteId").value
      )
      .subscribe((data) => {
        this.dataSource = data?.data?.[0]?.data ?? [];
        this.totalItems = data?.data?.[0]?.pageInfo?.[0]?.total ?? 0;
        this.paginator.length = this.totalItems;
      });
  }

  private getSortField(): keyof EmissionPointAttributes {
    const validSortFields: (keyof EmissionPointAttributes)[] = [
      "name",
      "statusId",
    ];
    return validSortFields.includes(
      this.sort.active as keyof EmissionPointAttributes
    )
      ? (this.sort.active as keyof EmissionPointAttributes)
      : "name";
  }

  onPageChange(event: PageEvent): void {
    this.pageSize = event.pageSize;
    this.pageIndex = event.pageIndex + 1;
    this.findAllWithCount();
  }

  onSearchChange(event: Event): void {
    const input = event.target as HTMLInputElement;
    this.searchQuery = input.value.trim();
    if (this.searchQuery.length >= 2 || this.searchQuery.length === 0) {
      // this.paginator.pageIndex = 0;
      this.findAllWithCount();
    }
  }

  public onHandleSearch() {
    this.searchSubscription = this.searchService.searchTerm$.subscribe(
      (term) => {
        this.searchQuery = term;
        if (this.searchQuery.length >= 2 || this.searchQuery.length === 0) {
          this.paginator.pageIndex = 0;
          this.findAllWithCount();
        }
      }
    );
  }

  onFilterPanelOpened(): void {
    this.loadFiltersData = true;
  }

  trackByFn(index: number, item: EmissionPointAttributes): string {
    return item._id.toString();
  }

  openCreateModal(): void {
    this.isSalesOfficeDisabled = false;
    this.isSubRouteDisabled = false;
    this.currentUpdateEmissionPoint = null;
    this.fetchAllApplication();
    this.fetchAllCompany();
    this.fetchAllSubRoute();
    this.currentCreateEmissionPoint = this.initializeCreateEmissionPoint();
    this.dialogRefAdd = this.dialog.open(this.addModal, {
      panelClass: "form-modal",
      disableClose: true,
    });
    // this.dialogRefAdd.afterClosed().subscribe((result) => result && this.createEmissionPoint());
    this.dialogRefAdd.afterClosed().subscribe((result) => {
      result;
    });
  }

  onSalesOfficeSelectionChange(event: any) {
    if (event && event.value.length > 0) {
      this.currentUpdateEmissionPoint.subRoute = null;
      this.isSubRouteDisabled = true; // Si selecciona oficina de venta, deshabilita ruta
    } else {
      this.isSubRouteDisabled = false; // Si no hay oficina de venta seleccionada, habilita ruta
    }
  }

  openEditModal(condition: EmissionPointAttributes): void {
    this.fetchAllApplication();
    this.fetchAllCompany();
    this.currentUpdateEmissionPoint = { ...condition, subRouteId: "" };

    // Obtener el ID de la sub-ruta actual
    const currentSubRouteId =
      condition.subRoute?._id?.toString() || condition.subRoute?.id?.toString();

    // Asignar el ID al campo subRouteId para que el select lo muestre seleccionado
    if (currentSubRouteId) {
      this.currentUpdateEmissionPoint.subRouteId = currentSubRouteId;
    }

    // Pasar el ID para incluir la sub-ruta actual en la lista
    this.fetchAllSubRoute(currentSubRouteId);

    this.dialogRefEdit = this.dialog.open(this.editModal, {
      panelClass: "form-modal",
      disableClose: true,
    });
    // this.dialogRefEdit.afterClosed().subscribe((result) => result && this.updateEmissionPoint(condition._id.toString()));
    this.dialogRefEdit.afterClosed().subscribe((result) => {
      result;
    });
  }

  createEmissionPoint(): void {
    if (
      this.salesOfficeMultiCtrl.value.length == 0 &&
      SourceToSetSerialEnum.SALES_OFFICE == this.currentCreateEmissionPoint.type
    ) {
      this.snackBar.open("Debe seleccionar la oficina de venta", "Cerrar", {
        duration: 3000,
      });
      return;
    }

    this.currentCreateEmissionPoint.salesOfficeIds =
      this.salesOfficeMultiCtrl.value.map((ware: SalesOfficeAttributes) =>
        ware._id.toString()
      );
    this.emissionPointService
      .create(this.currentCreateEmissionPoint)
      .subscribe({
        next: () => {
          this.snackBar.open("Registro creado con éxito", "Cerrar", {
            duration: 3000,
          });
          this.findAllWithCount();
          this.dialogRefAdd.close();
          this.salesOfficeMultiCtrl.reset();
        },
        error: (err) => {
          this.snackBar.open(
            err.error.message || "Error al crear el registro",
            "Cerrar",
            { duration: 3000 }
          );
        },
      });
  }

  updateEmissionPoint(id: string): void {
    if (this.currentUpdateEmissionPoint) {
      if (
        this.salesOfficeMultiCtrl.value.length == 0 &&
        SourceToSetSerialEnum.SALES_OFFICE ==
          this.currentUpdateEmissionPoint.type
      ) {
        this.snackBar.open("Debe seleccionar la oficina de venta", "Cerrar", {
          duration: 3000,
        });
        return;
      }

      const updatedEmissionPoint: IUpdateEmissionPoint = {
        ...this.currentUpdateEmissionPoint,
        companyId: this.currentUpdateEmissionPoint.company
          ? this.currentUpdateEmissionPoint.company._id.toString()
          : null,
        subRouteId: this.currentUpdateEmissionPoint.subRouteId || null,
        salesOfficeIds:
          this.salesOfficeMultiCtrl.value?.map(
            (sales: SalesOfficeAttributes) => sales._id?.toString() || null
          ) ?? null,
      };

      this.emissionPointService.update(id, updatedEmissionPoint).subscribe({
        next: () => {
          this.snackBar.open("Registro actualizado con éxito", "Cerrar", {
            duration: 3000,
          });
          this.findAllWithCount();
          this.dialogRefEdit.close();
          this.salesOfficeMultiCtrl.reset();
        },
        error: (err) => {
          this.snackBar.open(
            err.error.message || "Error al actualizar el registro",
            "Cerrar",
            { duration: 3000 }
          );
        },
      });
    }
  }

  onStatusChange(event: boolean, condition: EmissionPointAttributes): void {
    const originalStatusId = condition.statusId;
    const updatedStatusId = event ? 1 : 0;
    const updatedEmissionPoint: IUpdateEmissionPoint = {
      statusId: updatedStatusId,
    };

    this.emissionPointService
      .update(condition._id.toString(), updatedEmissionPoint)
      .subscribe({
        next: () => {
          this.findAllWithCount();
        },
        error: () => {
          condition.statusId = originalStatusId; // Volver al estado original si falla
          this.snackBar.open("Error al actualizar el estado.", "Cerrar", {
            duration: 3000,
          });
          this.findAllWithCount();
        },
      });
  }

  openDeleteDialog(condition: EmissionPointAttributes): void {
    this.dialog
      .open(this.deleteDialog, {
        data: condition,
        panelClass: "delete-modal",
        disableClose: true,
      })
      .afterClosed()
      .subscribe((result) => result && this.delete(condition._id.toString()));
  }

  openRangePage(condition: EmissionPointAttributes): void {
    const url = this.router.serializeUrl(
      this.router.createUrlTree(["/master/document/document-range"], {
        queryParams: { pointEmissionId: condition.id },
      })
    );
    window.open(url, "_blank");
  }

  delete(id: string): void {
    this.emissionPointService.remove(id).subscribe(() => {
      this.findAllWithCount();
      this.snackBar.open("Registro eliminado con éxito", "Cerrar", {
        duration: 3000,
      });
    });
  }

  compareById(item1: any, item2: any): boolean {
    return item1 && item2 ? item1._id === item2._id : item1 === item2;
  }

  onCompanySelectionChange(companyId: string): void {
    if (this.currentUpdateEmissionPoint) {
      this.currentUpdateEmissionPoint.company = this.companyList.find(
        (company) => company._id.toString() === companyId
      )!;
    }
  }

  onSubRouteSelectionChange(subRouteId: string): void {
    if (subRouteId) {
      this.salesOfficeMultiCtrl.setValue([]);
      this.isSalesOfficeDisabled = true; // Deshabilitar el campo de oficina
    } else {
      this.isSalesOfficeDisabled = false; // Habilitar el campo de oficina
    }

    if (this.currentUpdateEmissionPoint) {
      this.currentUpdateEmissionPoint.subRoute = this.subRouteList.find(
        (payment) => payment._id.toString() === subRouteId
      )!;
    }
  }

  clearFilters(): void {
    this.selectedCompanyIds = [];
    this.searchQuery = "";
    this.findAllWithCount();
  }

  getListTypeLabel(type: number): string {
    const labels = {
      [SourceToSetSerialEnum.COMPANY]: "COMPAÑIA",
      [SourceToSetSerialEnum.SALES_OFFICE]: "OFICINA DE VENTA",
      [SourceToSetSerialEnum.SUB_ROUTE]: "RUTA",
    };
    return labels[type] || type;
  }

  changeTypeCreate(event) {
    if (event.value == SourceToSetSerialEnum.COMPANY) {
      this.salesOfficeMultiCtrl.setValue([]);
      this.currentCreateEmissionPoint.salesOfficeIds = [];
      this.currentCreateEmissionPoint.subRouteId = null;
    }

    if (event.value == SourceToSetSerialEnum.SALES_OFFICE) {
      this.currentCreateEmissionPoint.subRouteId = null;
    }

    if (event.value == SourceToSetSerialEnum.SUB_ROUTE) {
      this.salesOfficeMultiCtrl.setValue([]);
      this.currentCreateEmissionPoint.salesOfficeIds = [];
    }
  }

  changeTypeUpdate(event: MatSelectChange) {
    if (event.value == SourceToSetSerialEnum.COMPANY) {
      this.salesOfficeMultiCtrl.setValue([]);
      this.currentUpdateEmissionPoint.salesOffices = [];
      this.currentUpdateEmissionPoint.subRoute = null;
    }

    if (event.value == SourceToSetSerialEnum.SALES_OFFICE) {
      this.currentUpdateEmissionPoint.subRoute = null;
      this.currentUpdateEmissionPoint.company = null;
    }

    if (event.value == SourceToSetSerialEnum.SUB_ROUTE) {
      this.salesOfficeMultiCtrl.setValue([]);
      this.currentUpdateEmissionPoint.salesOffices = [];
      this.currentUpdateEmissionPoint.company = null;
    }
  }

  onExportButtonPressed() {
    if (!this.emissionPointExport.canStartTask()) return;
    const dialogRef = this.dialog.open(ExportDialogComponent, {
      data: { title: EMISSION_POINT_TITLE },
    });
    dialogRef.afterClosed().subscribe((options: ExportOptions) => {
      if (options) {
        this.emissionPointExport.export(
          options.format,
          options.range,
          this.totalItems,
          this.pageSize,
          this.pageIndex
        );
      }
    });
  }

  ngOnDestroy(): void {
    this.searchSubscription.unsubscribe();
  }
}
